import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'
import noUiSlider from 'nouislider'

export default class SliderController extends Controller {
  static values = {
    variant: { type: String },
    min: { type: Number },
    max: { type: Number },
    step: { type: Number, default: 10 },
    isTooltip: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    initial: { type: Number, default: 0 }
  }

  formatForSlider = {
    from: function (formattedValue) {
      return Number(formattedValue)
    },
    to: function (numericValue) {
      return parseInt(numericValue)
    }
  }

  connect () {
    if (this.element.noUiSlider) {
      this.element.noUiSlider.destroy()
    }

    const config = this.getSliderConfig()
    noUiSlider.create(this.element, config)

    if (this.disabledValue) {
      this.disableSlider()
    }
  }

  disconnect () {
    if (this.element.noUiSlider) {
      this.element.noUiSlider.destroy()
    }
  }

  getSliderConfig () {
    switch (this.variantValue) {
      case 'single':
        return {
          start: this.initialValue || 0,
          connect: [true, false],
          format: this.formatForSlider,

          tooltips: !!this.isTooltipValue,
          range: { min: this.minValue, max: this.maxValue }
        }

      case 'steps':
        return {
          start: this.initialValue || 0,
          connect: [true, false],
          format: this.formatForSlider,
          tooltips: !!this.isTooltipValue,
          step: this.stepValue,
          // pips: { mode: 'steps', stepped: true, density: 100 },
          range: { min: this.minValue, max: this.maxValue }
        }

      case 'range':
        return {
          start: [0, 100],
          connect: true,
          format: this.formatForSlider,
          tooltips: [this.isTooltipValue, this.isTooltipValue],
          range: { min: this.minValue, max: this.maxValue }
        }

      default:
        return {
          start: 0,
          connect: [true, false],
          format: this.formatForSlider,
          tooltips: !!this.isTooltipValue,
          range: { min: this.minValue, max: this.maxValue }
        }
    }
  }

  disabledValueChanged () {
    if (!this.element.noUiSlider) return

    this.disabledValue ? this.disableSlider() : this.enableSlider()
  }

  disableSlider () {
    try {
      this.element.noUiSlider.disable()
    } catch (e) {
      console.error(e, 'noUiSlider disable API not available')
    }
  }

  enableSlider () {
    try {
      this.element.noUiSlider.enable()
    } catch (e) {
      console.error(e, 'noUiSlider enable API not available')
    }
  }
}

stimulus.register('slider', SliderController)
